import styled from 'styled-components';
import Footer from './Footer';
import Header from './Header';
import { mainBackground } from '../../style/colors';
import greenhouse from '../../assets/greenhouse.jpg';

const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;
const ContentContainer = styled.div`
    flex: 1;
    width: 100%;
    background: linear-gradient(${mainBackground}, ${mainBackground}),
        url(${greenhouse});
    background-size: cover;
    background-blend-mode: screen;
`;
const ContentInnerContainer = styled.div`
    padding: 0px 5%;
    /* max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px; */
`;

const MainLayout = ({ children, modelVersion, setModelVersion }) => {
    return (
        <MainContainer>
            <Header {...{ modelVersion, setModelVersion }} />
            <ContentContainer>
                <ContentInnerContainer>{children}</ContentInnerContainer>
            </ContentContainer>
            <Footer />
        </MainContainer>
    );
};

export default MainLayout;
